import { Link, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useIsMobile } from '@uplift/hooks';
import { Button } from '@uplift/ui-v2';

import { environment } from '../../../../../environments/environment';
import {
  StepContainer, StepContent, StepDescription, StepHeading, StepNavigator
} from '../../components';

export const InvalidLink: React.VFC = () => {
  const { classes } = useInvalidLinkStyles();
  const isMobile = useIsMobile('sm');

  return (
    <StepContainer>
      <StepContent className={classes.content}>
        <img
          className={classes.image}
          src="https://scdn.joinuplift.co/public/application-assets/broken_egg.png"
          alt="Invite link expired"
          data-testid="invalid-link-img"
        />
        <StepHeading>Your invite link expired or is no longer valid.</StepHeading>
        <StepDescription className={classes.description}>Check your email for the most recent invite or contact the person who invited you for a new link. Need help? Contact <Link href="mailto:help@joinuplift.co">help@joinuplift.co</Link></StepDescription>
      </StepContent>
      <StepNavigator>
        <div className={classes.loginContainer}>
          <Typography variant="body1">Already have an account?</Typography>
          {isMobile ? <Link href={environment.authUrl}>Sign in</Link> : <Button variant="text" color="secondary" onClick={() => window.location.href = environment.authUrl} data-testid="sign-in-btn">Sign in</Button>}
        </div>
      </StepNavigator>
    </StepContainer>
  );
};

const useInvalidLinkStyles = makeStyles({ name: 'InvalidLink' })(theme => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  image: {
    maxWidth: '159px',
    margin: theme.spacing(0, 'auto', 6),

    [theme.breakpoints.up('sm')]: {
      maxWidth: '197px',
    }
  },
  button: {
    marginTop: theme.spacing(3)
  },
  description: {
    marginTop: theme.spacing(3),
    '& a': {
      color: theme.palette.text.primary,
      textDecoration: 'underline',
    },

    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(2)
    }
  },
  loginContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    flex: 1,
    '& a': {
      color: theme.palette.text.primary,
      textDecoration: 'underline',
    },

    [theme.breakpoints.up('sm')]: {
      flex: 'unset',
    }
  }
}));
